<template>
  <div>
    <Card
      title="Detail Artist"
    >
      <template v-slot:button>
        <Button  @clicked="goBack" variant="default" label="Back" />
        <Button  @clicked="download" variant="primary" label="Download Statement" v-if="$route.query.fromDraft==undefined" />
      </template>
      <template v-slot:body>
        <div class="w-full">
          <ul class="flex mb-0 list-none flex-wrap pt-3 pb-4 flex-row">
            <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer " v-if="$route.query.fromDraft==undefined">
              <a class=" text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabsArtistDetail(1)" v-bind:class="{'text-blue-500 bg-white': detailArtistOpenTab !== 1, 'text-white bg-blue-500': detailArtistOpenTab === 1}">
                Profile
              </a>
            </li>
            <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer " v-if="$route.query.fromDraft==undefined">
              <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabsArtistDetail(2)" v-bind:class="{'text-blue-500 bg-white': detailArtistOpenTab !== 2, 'text-white bg-blue-500': detailArtistOpenTab === 2}">
                Song List
              </a>
            </li>
            <li class="-mb-px mr-2 last:mr-0 flex-auto text-center cursor-pointer " v-if="$route.query.fromDraft==undefined">
              <a class="text-xs font-bold uppercase px-5 py-3 shadow-lg rounded block leading-normal" v-on:click="toggleTabsArtistDetail(3)" v-bind:class="{'text-blue-500 bg-white': detailArtistOpenTab !== 3, 'text-white bg-blue-500': detailArtistOpenTab === 3}">
                Album List
              </a>
            </li>
          </ul>
          <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded">
            <div class="px-4 py-5 flex-auto">
              <div class="tab-content tab-space">
                <div v-bind:class="{'hidden': detailArtistOpenTab !== 1, 'block': detailArtistOpenTab === 1}" class="mx-400 overflow-y-auto">
                  <ArtistProfile ref="artist-profile" @on-save="onSaveProfile" :user="getArtist" ></ArtistProfile>
                </div>
                <div v-bind:class="{'hidden': detailArtistOpenTab !== 2, 'block': detailArtistOpenTab === 2}" class="mx-400 overflow-y-auto">
                  <ListSong :artistid="artistId" :toggle-reset="true" :musicverse-cut="getArtist.musicverse_cut" :artist-cut="getArtist.artist_cut" />
                </div>
                <div v-bind:class="{'hidden': detailArtistOpenTab !== 3, 'block': detailArtistOpenTab === 3}" class="mx-400 overflow-y-auto">
                  <ListAlbum :artistid="artistId" :toggle-reset="true" :musicverse-cut="getArtist.musicverse_cut" :artist-cut="getArtist.artist_cut" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </Card>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import ListSong from '../../components/Artist/ListSong';
import ListAlbum from '../../components/Artist/ListAlbum';
import ArtistProfile from './ArtistProfile';
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip';
import moment from 'moment';
import Card from '@/components/Layout/Card.vue';
import { Button } from '@/components/Layout/Form';
import axios from 'axios';
import { authHeader2 } from '@/helper/authHeader';
import fileDownload from 'js-file-download';

const API_URL = process.env.API_URL;

export default {
  name: 'ArtistDetailPage',
  data() {
    return {
      detailArtistOpenTab: 1,
      artistId: Number(this.$route.params.id),
    };
  },
  computed: {
    ...mapGetters('AuthModule', ['isSuperAdmin', 'isAdmin', 'isOps', 'isFinance']),
    ...mapGetters('ArtistModule', ['getArtist']),
  },
  async mounted() {
    this.artistId = Number(this.$route.params.id);
    await this.requestDetailArtist(this.artistId);
  },
  methods: {
    ...mapActions('NotificationModule', ['setLoading', 'unsetLoading']),
    ...mapActions('ArtistModule', ['requestDetailArtist', 'requestResendEmail', 'requestGetUrlStatement']),
    goBack(){
      this.$router.push(this.$route.query.fromDraft!==undefined?'/artists/draft':'/artists')
    },
    toggleTabsArtistDetail(tabNumber) {
      this.detailArtistOpenTab = tabNumber;
    },
    async onSaveProfile(state) {
      await this.requestDetailArtist(this.artistId);
    },
    async download(){
      this.setLoading()
      axios({
        url: `${API_URL}/admin/user-artist/statement`,
        method: 'get',
        params:{user_id:this.artistId},
        headers:  authHeader2(),
        responseType: 'blob',
      }).then(res => {
        fileDownload(res.data, 'statement-download.pdf');
        this.unsetLoading()
      }).catch((err) => {
        this.unsetLoading()
        this.$swal('Error', 'No Statement Found', 'error');
        throw err.response;
      });
    }
  },
  components: { ListSong, ListAlbum, ArtistProfile, Card,
    Button, },
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/ArtistContent/ArtistDetail.vue